import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  mapContainer: {
    height: "100%",
  },
  vectorContainer: {
    margin: -theme.spacing(3)
  }
}));